// extracted by mini-css-extract-plugin
module.exports = {"ldsSpinner":"upload-spinner_ldsSpinner__1d2L7","lds-spinner":"upload-spinner_lds-spinner__1ruoz"};